"use strict";

var _defineProperty = require("C:\\React Things\\v-onboarding\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/defineProperty");

var _charsets;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generate = exports.generateOne = exports.charset = exports.Charset = void 0;
var Charset;

(function (Charset) {
  Charset["NUMBERS"] = "numbers";
  Charset["ALPHABETIC"] = "alphabetic";
  Charset["ALPHANUMERIC"] = "alphanumeric";
})(Charset = exports.Charset || (exports.Charset = {}));

var placeholder = '#';

var size = function size(fn, array) {
  return fn ? Array.from(array).filter(function (x) {
    return fn(x);
  }).length : array.length;
};

var randomInt = function randomInt(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

var randomElement = function randomElement(array) {
  return array[randomInt(0, array.length - 1)];
};

var charsets = (_charsets = {}, _defineProperty(_charsets, Charset.NUMBERS, '0123456789'), _defineProperty(_charsets, Charset.ALPHABETIC, 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'), _defineProperty(_charsets, Charset.ALPHANUMERIC, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'), _charsets);

var charset = function charset(name) {
  return charsets[name];
};

exports.charset = charset;

var createConfig = function createConfig() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _a, _b, _c, _d, _e, _f, _g;

  return {
    count: (_a = config.count) !== null && _a !== void 0 ? _a : 1,
    length: (_b = config.length) !== null && _b !== void 0 ? _b : 8,
    charset: (_c = config.charset) !== null && _c !== void 0 ? _c : (0, exports.charset)(Charset.ALPHANUMERIC),
    prefix: (_d = config.prefix) !== null && _d !== void 0 ? _d : '',
    postfix: (_e = config.postfix) !== null && _e !== void 0 ? _e : '',
    pattern: (_f = config.pattern) !== null && _f !== void 0 ? _f : placeholder.repeat((_g = config.length) !== null && _g !== void 0 ? _g : 8)
  };
};

var generateOne = function generateOne(_ref) {
  var pattern = _ref.pattern,
      charset = _ref.charset,
      prefix = _ref.prefix,
      postfix = _ref.postfix;
  var code = '';

  var _iterator = _createForOfIteratorHelper(pattern),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var p = _step.value;
      var c = p === placeholder ? randomElement(charset) : p;
      code += c;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return "".concat(prefix).concat(code).concat(postfix);
};

exports.generateOne = generateOne;

var isFeasible = function isFeasible(charset, pattern, count) {
  return Math.pow(charset.length, size(function (x) {
    return x === placeholder;
  }, pattern)) >= count;
};

var generate = function generate(config) {
  var validatedConfig = createConfig(config);
  var charset = validatedConfig.charset,
      count = validatedConfig.count,
      pattern = validatedConfig.pattern;

  if (!isFeasible(charset, pattern, count)) {
    throw new Error('Not possible to generate requested number of codes.');
  }

  var codes = new Set();

  while (codes.size < count) {
    codes.add((0, exports.generateOne)(validatedConfig));
  }

  return Array.from(codes);
};

exports.generate = generate;